import {
  LOADING,
  SUBMITTED_PIE_CHART_TEAM,
  SUBMITTED_SUMMARY_TEAM,
  SUBMITTED_TEAM_TEAM_TABLE,
  INDIVIDUAL_ROLE,
} from '@pages/SalesReport/constants.js';
import {
  SET_SALES_REPORT_BREADCRUMB_DATA,
  SET_SALES_REPORT_DATETIME_DATA,
  SET_SALES_REPORT_SELECTED_TAB_DATA,
  SET_SALES_REPORT_SUMMARY_DATA,
  SET_SALES_REPORT_TABLE_DATA,
  SET_SALES_REPORT_FILTER,
  SET_SALES_REPORT_POLICY_DATA,
  SET_SALES_REPORT_SELECTED_BREADCRUMB_ID,
  SET_SALES_REPORT_PIE_CHART_DATA,
  RESET_STATE,
  FETCH_TEAM_POLICY_LIST_START,
  FETCH_TEAM_POLICY_LIST_SUCCESS,
} from './constants.js';

export const initialState = {
  datetimeData: [],
  salesData: {},
  salesSummaryData: {},
  pieChartData: {},
  breadcrumbData: {},
  configFilter: {
    action: LOADING,
    timeType: 'monthly',
    timeValue: '',
    summaryType: SUBMITTED_SUMMARY_TEAM,
    pieChartType: SUBMITTED_PIE_CHART_TEAM,
    tableType: SUBMITTED_TEAM_TEAM_TABLE,
    code: 'ACT12',
    codeType: INDIVIDUAL_ROLE,
    page: 0,
    size: 10,
    sort: 'afyp:DESC',

    submittedDateFrom: '',
    submittedDateTo: '',
    appReceivedDateFrom: '',
    appReceivedDateTo: '',
    issuedDateFrom: '',
    issuedDateTo: '',
    appNumber: '',
    policyNumber: '',
    policyStatusCode: '',
    policySort: 'submitted_dt:DESC',
    isTopNode: false,
    isDirectHierarchy: false,
    isIndirectHierarchy: false,
  },
  selectedBreadcrumbId: 'ACT1',
  policyData: [],
  policyDetailData: null,
  selectedTabId: INDIVIDUAL_ROLE,
  isLoadingTeamPolicyList: false,
};

const salesReportReducers = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_SALES_REPORT_DATETIME_DATA:
      state = {
        ...state,
        datetimeData: payload,
      };
      break;
    case SET_SALES_REPORT_TABLE_DATA:
      state = {
        ...state,
        salesData: payload,
      };
      break;
    case SET_SALES_REPORT_FILTER:
      state = {
        ...state,
        configFilter: payload,
      };
      break;
    case SET_SALES_REPORT_SUMMARY_DATA:
      state = {
        ...state,
        salesSummaryData: payload,
      };
      break;
    case SET_SALES_REPORT_PIE_CHART_DATA:
      state = {
        ...state,
        pieChartData: payload,
      };
      break;
    case SET_SALES_REPORT_BREADCRUMB_DATA:
      state = {
        ...state,
        breadcrumbData: payload,
      };
      break;
    case SET_SALES_REPORT_SELECTED_BREADCRUMB_ID:
      state = {
        ...state,
        selectedBreadcrumbId: payload,
      };
      break;
    case SET_SALES_REPORT_SELECTED_TAB_DATA:
      state = {
        ...state,
        selectedTabId: payload,
      };
      break;
    case SET_SALES_REPORT_POLICY_DATA:
      state = {
        ...state,
        policyData: payload,
      };
      break;
    case RESET_STATE:
      state = {
        ...initialState,
      };
      break;
    case FETCH_TEAM_POLICY_LIST_START:
      state = {
        ...state,
        isLoadingTeamPolicyList: true,
      };
      break;
    case FETCH_TEAM_POLICY_LIST_SUCCESS:
      state = {
        ...state,
        isLoadingTeamPolicyList: false,
      };
      break;
    default:
      break;
  }
  return state;
};

export default salesReportReducers;
